export var AfriexRewardTier;
(function (AfriexRewardTier) {
    AfriexRewardTier["Member"] = "member";
    AfriexRewardTier["Blue"] = "blue";
    AfriexRewardTier["Gold"] = "gold";
    AfriexRewardTier["Platinum"] = "platinum";
})(AfriexRewardTier || (AfriexRewardTier = {}));
//# sourceMappingURL=AfriexRewardTier.js.map